import { VcsMessagingControllerService } from 'api';
import { getLogger, LOGGERS } from 'lib/logger';
import { selectCallConfig } from 'state/selectors/app';
import { selectIsAuthorized, selectRoomId } from 'state/selectors';
import { getWaitingListId } from './session';

const logger = getLogger(LOGGERS.WaitingRoom);

/**
 * Сообщить бэкенду, что пользователь сам вышел из очереди waiting room.
 * Не блокирует UI; ошибки только в консоль.
 */
export async function cancelWaitingForJoinIfNeeded(
    overrides?: { waitingListId?: string; roomName?: string },
    options?: { keepalive?: boolean },
): Promise<void> {
    const waitingListId = overrides?.waitingListId ?? getWaitingListId() ?? '';
    const roomName = overrides?.roomName ?? selectRoomId() ?? '';
    if (!waitingListId || !roomName) {
        return;
    }

    const body = { roomName, waitingListId };
    const workspaceId = selectCallConfig()?.workspaceId;

    try {
        if (selectIsAuthorized()) {
            const { error } = await VcsMessagingControllerService.cancelWaitingForJoinOAuth(body, options);
            if (error) {
                logger.warn('[waitingRoom] cancelWaitingForJoinOAuth failed', error);
            }
            return;
        }

        if (workspaceId != null && workspaceId > 0) {
            const { error } = await VcsMessagingControllerService.cancelWaitingForJoin(workspaceId, body, options);
            if (error) {
                logger.warn('[waitingRoom] cancelWaitingForJoin failed', error);
            }
            return;
        }

        const { error } = await VcsMessagingControllerService.cancelWaitingForJoinOAuth(body, options);
        if (error) {
            logger.warn('[waitingRoom] cancelWaitingForJoinOAuth (no workspace) failed', error);
        }
    } catch (e) {
        logger.error('[waitingRoom] cancel waiting threw', e);
    }
}
